/**
 * Simple `<form>` HTML tag with added support for submitting it through the CTRL + Enter shortcut.
 */
export function FormWithShortcuts({
  onSubmit,
  ...props
}: JSX.IntrinsicElements['form']) {
  return (
    <form
      onKeyDownCapture={(event) => {
        if (event.metaKey && event.key === 'Enter') {
          onSubmit?.(event);
        }
      }}
      onSubmit={onSubmit}
      {...props}
    />
  );
}
